import { FilterActionTypes, FilterState, FilterActions, FilterKeyTypes, FilterType, ColorToggleItem } from "./types";
import { FileCategories } from "constants/filenames";
import { Category } from "fileParsing/types";

// Initial state
const initialState: FilterState = {
  active: [FilterType.categories],
  categories: Object.values(Category).map((d) => {
    return {
      value: true,
      id: d,
      color: "",
      label: d,
      key: d,
      amount: 0,
    };
  }),
  subcategories: [],
  locations: [],
  providers: [],
  messageCount: [],
  fileTypes: Object.entries(FileCategories).map((d) => {
    return {
      value: true,
      id: d[1].type,
      color: d[1].color,
      label: d[1].name,
      key: d[1].type,
      amount: 0,
    };
  }),
  selection: [undefined, undefined],
  contactFilterRange: { min: 1, max: +Infinity },
};

function switchToggleInArray(array: ColorToggleItem[], id: string) {
  return array.map((item) =>
    item.id !== id
      ? item
      : {
          ...item,
          ...{
            value: !item.value,
          },
        },
  );
}

function createList(array: [string, string][]): ColorToggleItem[] {
  return array.map((item) => {
    return {
      value: true,
      id: item[0],
      color: item[1],
      label: item[0],
      key: item[0] as FilterKeyTypes,
      amount: 0, // TODO: add amount
    };
  });
}

// The reducer function
export function filterReducer(state = initialState, action: FilterActions): FilterState {
  switch (action.type) {
    case FilterActionTypes.TOGGLE_ITEM: {
      // actually handles select and deselect currently
      const { filter, id } = action.payload;
      switch (filter) {
        case FilterType.categories:
          return {
            ...state,
            categories: switchToggleInArray(state.categories, id),
          };
        case FilterType.subcategories:
          return {
            ...state,
            subcategories: switchToggleInArray(state.subcategories, id),
          };
        case FilterType.locations:
          return {
            ...state,
            locations: switchToggleInArray(state.locations, id),
          };
        case FilterType.providers:
          return {
            ...state,
            providers: switchToggleInArray(state.providers, id),
          };
        case FilterType.fileTypes:
          return {
            ...state,
            fileTypes: switchToggleInArray(state.fileTypes, id),
          };
        default:
          throw new Error(`Unkown filter label for CategoriesActionTypes.TOGGLE_ITEM: ${filter}, ${id}`);
      }
    }
    case FilterActionTypes.SELECT_ALL: {
      const { filter } = action.payload;
      switch (filter) {
        case FilterType.categories:
          return {
            ...state,
            categories: state.categories.map((d) => {
              return { ...d, value: true };
            }),
          };
        case FilterType.subcategories:
          return {
            ...state,
            subcategories: state.subcategories.map((d) => {
              return { ...d, value: true };
            }),
          };
        case FilterType.locations:
          return {
            ...state,
            locations: state.locations.map((d) => {
              return { ...d, value: true };
            }),
          };
        case FilterType.providers:
          return {
            ...state,
            providers: state.providers.map((d) => {
              return { ...d, value: true };
            }),
          };
        case FilterType.fileTypes:
          return {
            ...state,
            fileTypes: state.fileTypes.map((d) => {
              return { ...d, value: true };
            }),
          };
        default:
          throw new Error(`Unkown filter label for CategoriesActionTypes.UPDATE_COLOR: ${filter}`);
      }
    }
    case FilterActionTypes.DESELECT_ALL: {
      const { filter } = action.payload;
      switch (filter) {
        case FilterType.categories:
          return {
            ...state,
            categories: state.categories.map((d) => {
              return { ...d, value: false };
            }),
          };
        case FilterType.subcategories:
          return {
            ...state,
            subcategories: state.subcategories.map((d) => {
              return { ...d, value: false };
            }),
          };
        case FilterType.locations:
          return {
            ...state,
            locations: state.locations.map((d) => {
              return { ...d, value: false };
            }),
          };
        case FilterType.providers:
          return {
            ...state,
            providers: state.providers.map((d) => {
              return { ...d, value: false };
            }),
          };
        case FilterType.fileTypes:
          return {
            ...state,
            fileTypes: state.fileTypes.map((d) => {
              return { ...d, value: false };
            }),
          };
        default:
          throw new Error(`Unkown filter label for CategoriesActionTypes.UPDATE_COLOR: ${filter}`);
      }
    }
    case FilterActionTypes.SET_ACTIVE_FILTERS: {
      const { active } = action.payload;
      return { ...state, active };
    }
    case FilterActionTypes.UPDATE_COLOR: {
      // handles deselect all folders and select all folders
      // TODO: Implement method for views to change the color layout of filters
      return state;
    }
    case FilterActionTypes.UPDATE_SUBCATEGORY: {
      // TODO: implement
      return { ...state, subcategories: createList([]) };
    }
    case FilterActionTypes.SET_TIMELINESELECTION: {
      const { selection } = action.payload;
      return { ...state, selection };
    }
    case FilterActionTypes.UPDATE_CONTACT: {
      const { range } = action.payload;

      return {
        ...state,
        contactFilterRange: range,
      };
    }
    default: {
      return state;
    }
  }
}
